import { fetchWrapper } from '../../../services/fetchServices/fetchWrapper';

export function deleteCategory(id: number) {
  return fetchWrapper({
    url: `/api/hardware/category/${id}`,
    fetchArg: {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  });
}
